
























































































import Vue from 'vue'

export default Vue.extend({
  name: 'ToggleSwitch',
  props: {
    checked: {
      type: Boolean,
      required: false,
      default: true
    },
    inputName: {
      type: String,
      required: false,
      default: ''
    }
  }
})
